import { Agent, ArticleType, CustomTheme, PaymentMethodType } from '@nemuru-eng/js-api-client';

import { CartEntity } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/entities/CartEntity';
import { ApplicationStep, ApplicationStepValue } from '@/components/modules/Application/types/ApplicationStep';
import { useApplicationContext } from '@/contexts/ApplicationContext/ApplicationContext';
import { useUser } from '@/hooks/useUser';

export const useGetApplicationSteps = () => {
  const { isUserAgent, agent: userEntityAgent } = useUser();

  const {
    state: { selectedAgent, cart },
  } = useApplicationContext();

  const getSteps = (cartOverride?: CartEntity) => {
    const agent = selectedAgent ?? userEntityAgent;
    const cartToUse = cartOverride ?? cart;

    const cartSteps: ApplicationStepValue[] = hasAgentOnlyAutoPaymentMethods(agent)
      ? [ApplicationStep.AUTO_CART]
      : agent?.customTheme === CustomTheme.KTUIN
      ? [ApplicationStep.KTUIN_CART]
      : [ApplicationStep.REFERENCES, ApplicationStep.DEFAULT_CART];

    const postCartSteps = isAutoApplicationFlow(agent, cartToUse)
      ? [
          ApplicationStep.CONTACT_INFORMATION,
          ApplicationStep.PAYMENT_METHOD,
          ApplicationStep.CHECKOUT_SESSION_CREATION,
        ]
      : [
          ApplicationStep.PAYMENT_METHOD,
          ApplicationStep.CONTACT_INFORMATION,
          ApplicationStep.CHECKOUT_SESSION_CREATION,
        ];

    return [...(!isUserAgent ? [ApplicationStep.AGENT_SELECTION] : []), ...cartSteps, ...postCartSteps] as ApplicationStepValue[];
  };

  return {
    getSteps,
  };
};

export const isAutoApplicationFlow = (agent: Agent | undefined, cart: CartEntity | undefined) => {
  return hasAgentOnlyAutoPaymentMethods(agent) || cart?.cartArticleType() === ArticleType.AUTOMOBILE;
};

const hasAgentOnlyAutoPaymentMethods = (agent: Agent | undefined) => {
  if (!agent) return undefined;
  const allowedPaymentMethods = agent?.allowedPaymentMethodTypes;
  if (!allowedPaymentMethods || allowedPaymentMethods.length === 0) return false;

  const autoPaymentMethodTypes = [PaymentMethodType.AUTO_LOAN, PaymentMethodType.B2B_LOAN];
  return (
    allowedPaymentMethods.length <= 2 && allowedPaymentMethods.every((type) => autoPaymentMethodTypes.includes(type))
  );
};
